import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { initGtag } from "../lib/gtag";

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem("bps-consent"));

  useEffect(() => {
    if (choice === "accept") initGtag();
  }, [choice]);

  const decide = (val) => {
    localStorage.setItem("bps-consent", val);
    setChoice(val);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-xl rounded-2xl border border-sage/15 bg-white/90 p-5 shadow-[0_20px_50px_-15px_rgba(31,36,33,0.25)] backdrop-blur-xl sm:left-auto sm:right-6"
          data-testid="cookie-consent-banner"
        >
          <p className="text-sm leading-relaxed text-ink/70">
            We use cookies to keep the shop running and — only with your permission — to measure
            how visitors find us. Read our{" "}
            <Link to="/privacy" className="text-sage underline underline-offset-2">privacy policy</Link>.
          </p>
          <div className="mt-4 flex gap-3">
            <button
              onClick={() => decide("accept")}
              data-testid="cookie-accept-button"
              className="rounded-full bg-sage px-6 py-2.5 text-xs font-medium uppercase tracking-[0.12em] text-cream transition-colors hover:bg-sage-deep"
            >
              Accept
            </button>
            <button
              onClick={() => decide("decline")}
              data-testid="cookie-decline-button"
              className="rounded-full border border-ink/15 px-6 py-2.5 text-xs font-medium uppercase tracking-[0.12em] text-ink/60 transition-colors hover:border-sage hover:text-sage"
            >
              Decline
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
